import styled from "styled-components";


export const SidebarPopupWrapper = styled.div`
@media print {
 
    display: none !important;
 
}
 position: fixed;
 overflow: auto;
opacity: 1;
    z-index: 10000;
    position: fixed;
    width: 100%;
    height: 100%;
   
    top: 0;
    left: 0;
    z-index: 1000;
    /* visibility: hidden; */
    /* opacity: 0; */
    display: flex;
    background: rgba(40, 43, 49, .8);
    transition: all .3s;
    ::-webkit-scrollbar {
  width: 0px; 
  height: 0;
}
    &.visible {
    opacity: 1;
    visibility: visible;

    
}
&>.close{
       width: 100%;
       height: 100%;
    }
.sidebar{

    position: absolute;
    right: -10px;
    top: 0;
    height: 100%;
    background: rgb(249, 249, 249);
    color: #000;
box-shadow: 0px 2px 50px #0029702E;
width: 100%;
max-width: 800px;
font-family: "Rubik", sans-serif;
  overflow: hidden;
  display: flex;
  flex-direction: column;


.sidebarHeader{
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    padding: 20px 30px ;
    /* border-bottom: 1px solid #000; */
   // position: sticky;
    top: 0;
    z-index: 1;
    background-color: inherit;
    .left{
        h2{
            color: #000;
            font-size: 25px;
        }

    }
   .right{
cursor: pointer;
   }
}
.body{
  padding: 4px 30px 30px;
   overflow-y: auto;
  flex: 1; 
  &>div{
    margin-bottom: 10px;
  }
}
.SidebarFooter{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px 30px;
 background-color: inherit;
  box-shadow: rgb(0 0 0 / 37%) -1px -2px 13px 0px;
}
 .buttons{
        display: flex;
        gap:10px;
       button{
        background: #0E5EEA ;
box-shadow: 0px 2px 3px #0029700D;
border: 1px solid #00297024;
border-radius: 5px;
font-weight: 500;
color: #fff;
transition: all .3s;
text-transform: capitalize;
padding: 8px;
&:hover{
    background:rgb(4, 63, 165) ;
}

       }
       button{
        &:disabled{
          background: #ddd;
          color: #000;
          cursor: not-allowed;
       }
      }
    }
}
`; 

export const DropDownBox = styled.div`
background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 1px 2px #00000029;
border-radius: 15px;
padding: 16px 30px 30px;

h2{
    font-size: 15px;
    line-height: 17px;
    margin-bottom: 10px;
}
.document{
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
      flex: 1 1 23% !important;
}
.badge {
  display: inline-block;
  padding: 4px 8px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 12px;
  color: white;
  text-transform: uppercase;
}

.approve {
  background-color: #28a745; /* Green */
}

.reject {
  background-color: #dc3545; /* Red */
}
.pending {
  background-color: #ffc107; /* Yellow/Orange */
  color: #212529; /* Dark text for contrast */
}
.row{
    display: flex;
   gap: 20px;

    .column{
     flex: 0 0 calc(25% - 7px);
     color: #333333c2;
         .title{
           font-size: 13px;
           line-height: 25px;
           font-weight: 700;
           text-transform: capitalize;
         }
         .value{
           font-size: 13px;
           line-height: 25px;
           color: #000;
         }
      .verify{
        display: flex;
        gap: 4px;
        align-items: center;
        color: #4CAF50;
        font-weight: 700;
            font-size: 13px;
        img{
            width: 14px;
            font-size: 13px;
        }

      } 
      .Noverify{
        display: flex;
        gap: 4px;
        align-items: center;
        color: gray;
        font-weight: 700;
        font-size: 13px;
        img{
            width: 14px;
        
            filter: grayscale(1);
        }
      }
      .status{

      }
      .buttons{
        display: flex;
        gap:10px;
       button{
        background: #0E5EEA ;
box-shadow: 0px 2px 3px #0029700D;
border: 1px solid #00297024;
border-radius: 5px;
font-weight: 500;
color: #fff;
transition: all .3s;
text-transform: capitalize;
padding: 8px;
&:hover{
    background:rgb(4, 63, 165) ;
}

       }
       button{
        &:disabled{
          background: #ddd;
          color: #000;
          cursor: not-allowed;
       }
      }
      }  
    }
}

`;